import ApiClient from "../aquaart-group";
import { VacanciesListResource } from "../generated-api";

export class ApiVacancies {
  static async getVacancies(lang: string): Promise<VacanciesListResource> {
    return ApiClient.get<VacanciesListResource>("/vacancies");
  }
}
